import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import "./style.scss";

interface ModalProps {
  modal: boolean;
  body: any;
  header: any;
  onClose: () => void;
  styles?: any;
  showModalCloseButton?: boolean;
  closeOnOverlayClick?: boolean;
}

export const ModalWrapper = ({
  modal,
  body,
  header,
  onClose,
  styles,
  showModalCloseButton = true,
  closeOnOverlayClick = true,
}: ModalProps) => {
  return (
    <Modal
      isOpen={modal}
      onClose={onClose}
      closeOnOverlayClick={closeOnOverlayClick}
      isCentered
    >
      <ModalOverlay bg="brand.modalOverlay" />
      <ModalContent
        minW="550px"
        bg="brand.backgroundLight"
        m="1rem"
        {...styles}
      >
        <ModalHeader fontSize="1rem" mt="0.5rem">
          {header}
        </ModalHeader>
        {showModalCloseButton && (
          <ModalCloseButton
            mt="0.8rem"
            _focus={{
              boxShadow: "none",
            }}
          />
        )}
        <ModalBody>{body}</ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalWrapper;
